import styled from 'styled-components';
import Text from '@service-victoria/component-library/components/Text';
import colors from '@service-victoria/component-library/utils/colors';

export const FieldRow = styled.span`
  display: flex;
  flex-direction: column;
  margin-top: 2px;
  margin-bottom: 2px;
`;

export const FieldTitle = styled(Text.Body)`
  background-color: ${colors.orange10};
  margin-top: 2px;
  margin-bottom: 0px;
  margin-left: 20px;
`;

export const FieldValue = styled(Text.Body)`
  font-weight: bold;
  background-color: ${colors.orange10};
  margin-top: 0px;
  margin-bottom: 2px;
  margin-left: 20px;
`;
